import { ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SearchServiceOrder } from "../../../../entities/service-order/api/search-service-orders";

interface ServiceOrderListItemComponentProps {
  serviceOrder: SearchServiceOrder;
}

const ServiceOrderListItemComponent = ({ serviceOrder }: ServiceOrderListItemComponentProps) => {
  const navigate = useNavigate();

  const formattedDate = new Date(serviceOrder.created_at).toLocaleDateString("pt-BR");
  
  const status = serviceOrder.finished ? "Finalizada" : "Em Andamento";

  return (
    <ListItem key={serviceOrder.service_order_id} divider>
      <ListItemButton
        onClick={() => navigate(`/service-orders/${serviceOrder.service_order_id}/update`)}
        role={undefined}
        dense
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-end",
          textAlign: "center"
        }}
      >
        <ListItemText 
          id={`costumer-${serviceOrder.service_order_id}`} 
          primary={serviceOrder.costumer_name} 
          sx={{ flex: "1" }} 
        />
        <ListItemText 
          id={`date-${serviceOrder.service_order_id}`} 
          primary={formattedDate} 
          sx={{ flex: "1" }} 
        />
        <ListItemText 
          id={`line-count-${serviceOrder.service_order_id}`} 
          primary={serviceOrder.service_order_line_count.toString()} 
          sx={{ flex: "1" }} 
        />
        <ListItemText 
          id={`status-${serviceOrder.service_order_id}`} 
          primary={status} 
          sx={{ flex: "1" }} 
        />
      </ListItemButton>
    </ListItem>
  );
};

export default ServiceOrderListItemComponent;
